import { CommentStatus } from './types';
import { makeRequest, CommonRequestOptions } from '../makeRequest';
import { getUnixTime } from 'date-fns';

export type ChangeCommentStatusOptions = {
   commentid: number;
   status: CommentStatus;
};

export async function changeCommentStatus(
   options: ChangeCommentStatusOptions,
   { ...common }: CommonRequestOptions = {}
): Promise<void> {
   const now = getUnixTime(Date.now());
   return makeRequest('put', `comments/${options.commentid}/status`, {
      ...common,
      body: {
         to: options.status,
         date: now,
      },
   });
}
